/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdateFirmwareTask
 */
export interface UpdateFirmwareTask {
    /**
     *
     * @type {string}
     * @memberof UpdateFirmwareTask
     */
    location?: string;
}

/**
 * Check if a given object implements the UpdateFirmwareTask interface.
 */
export function instanceOfUpdateFirmwareTask(
    value: object,
): value is UpdateFirmwareTask {
    return true;
}

export function UpdateFirmwareTaskFromJSON(json: any): UpdateFirmwareTask {
    return UpdateFirmwareTaskFromJSONTyped(json, false);
}

export function UpdateFirmwareTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UpdateFirmwareTask {
    if (json == null) {
        return json;
    }
    return {
        location: json["location"] == null ? undefined : json["location"],
    };
}

export function UpdateFirmwareTaskToJSON(
    value?: UpdateFirmwareTask | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        location: value["location"],
    };
}
